var mobNavInitialised = false;
var desktopNavInitialised = false;

var originalWindowHeight = window.innerHeight

const sticky_nav = function () {

    var originalWidth = window.innerWidth;

    if (window.innerWidth >= 768) {
        desktop_nav();
    }

    if (window.innerWidth < 768) {
        if(!mobNavInitialised){
            mobNavInitialised = true;
            mobile_nav_simple();
        }
    }

    window.addEventListener("resize", function (e) {


        if (window.innerWidth != originalWidth) {

            if (window.innerWidth >= 768) {
                if(!desktopNavInitialised){
                    desktopNavInitialised = true
                    desktop_nav();
                }
            }

            if (window.innerWidth < 768) {
                if(!mobNavInitialised){
                    mobNavInitialised = true;
                    mobile_nav_simple();
                }
            }

        }

    });
}

function desktop_nav() {

    var nav_display = document.getElementById('lccNavDisplayBar');
    var lcc_nav = document.getElementById('lccNavDesktop');
    var lcc_nav_container = document.getElementById('lccNavDesktopContainer');

    window.addEventListener("scroll", function () {

        // lcc_nav.classList.remove('lcc_nav_open');
        if (window.scrollY > (window.pageYOffset + lcc_nav_container.getBoundingClientRect().top + lcc_nav_container.offsetHeight)) {
            lcc_nav_container.classList.add('lccc-nav-desktop__container--fixed')
            nav_display.classList.add('lccc-nav__displaybar--visible')

            lcc_nav_container.classList.remove('lccc-nav-desktop__container--open')
        } else {
            lcc_nav_container.classList.remove('lccc-nav-desktop__container--fixed')
            nav_display.classList.remove('lccc-nav__displaybar--visible')
        }
    });

    nav_display.addEventListener("click", function () {
        lcc_nav_container.classList.add('lccc-nav-desktop__container--open')
        nav_display.classList.remove('lccc-nav__displaybar--visible')
    });

    nav_display.addEventListener("mouseover", function () {
        lcc_nav_container.classList.add('lccc-nav-desktop__container--open')
        nav_display.classList.remove('lccc-nav__displaybar--visible')
    });

    lcc_nav.addEventListener("mouseleave", function () {
        if(lcc_nav_container.classList.contains('lccc-nav-desktop__container--fixed')){
            lcc_nav_container.classList.remove('lccc-nav-desktop__container--open')
            nav_display.classList.add('lccc-nav__displaybar--visible')
        }
    });

}


function mobile_nav_simple(){
    var nav_display = document.getElementById('lccNavDisplayBar');
    var lcc_nav = document.getElementById('lccNavMobile');
    var lcc_nav_more = document.getElementById('lccNavMore');


    var oldScrollValue = 0
    var newScrollValue = 0

    var direction = 'up'

    var touchStart = false;
    var scrollDistance = 0;

    var lccNavDrawer = document.getElementById('lccNavDrawer');

    var oldWindowHeight = window.innerHeight
    var newWindowHeight = 0
    var resizeAmount = 0


    window.addEventListener("resize", function (e) {

        if(window.pageYOffset >= 0){

            //console.log('resized')

            newWindowHeight = window.innerHeight
            resizeAmount = (oldWindowHeight - newWindowHeight)

            if(resizeAmount < 0){
                if(direction == 'up'){
                    //console.log('hiding')
                    hideMobNav()
                }
            }

            if(window.pageYOffset > 0){
                oldWindowHeight = newWindowHeight
            }
        }

    });

    $(window).scroll(function (event) {

        if(window.pageYOffset > 0){

            //console.log('scrolling')

            newScrollValue = window.pageYOffset;

            if (oldScrollValue < newScrollValue) {
                if(direction == 'up'){
                    hideMobNav()
                }
            } else if (oldScrollValue > newScrollValue) {
                if(direction == 'down'){
                    showMobNav()
                }
            }
            oldScrollValue = newScrollValue;

        }

    })

    lcc_nav_more.addEventListener('click', function (e) {

        if (lcc_nav.classList.contains('lccc-nav__drawer--up')) {
            lcc_nav.classList.remove('lccc-nav__drawer--up');
            lcc_nav_more.classList.remove('lccc-nav__item--active')
        } else {
            lcc_nav.classList.add('lccc-nav__drawer--up');
            lcc_nav_more.classList.add('lccc-nav__item--active')
        }
        e.preventDefault();

    });

    function hideMobNav() {
        direction = 'down'
        lcc_nav.classList.add('lccc-nav--down')
        lcc_nav.classList.remove('lccc-nav--up')
        if(lcc_nav.classList.contains('lccc-nav__drawer--up')){
            lcc_nav.classList.remove('lccc-nav__drawer--up')
            lcc_nav_more.classList.remove('lccc-nav__item--active')
        }
    }

    function showMobNav() {
        direction = 'up'
        lcc_nav.classList.remove('lccc-nav--down')
        lcc_nav.classList.add('lccc-nav--up')
    }

}



function mobile_nav_smooth() {
    
    var nav_display = document.getElementById('lccNavDisplayBar');
    var lcc_nav = document.getElementById('lccNavMobile');

    var oldScrollValue = 0
    var newScrollValue = 0

    var direction = 'down'

    var touchStart = false;
    var scrollDistance = 0;

    var lccNavDrawer = document.getElementById('lccNavDrawer');
    var lccNavMoreImageInactive = document.getElementById('lccNavMoreImageInactive');
    var lccNavMoreImageActive = document.getElementById('lccNavMoreImageActive');

    var touching = false



    console.log('original', originalWindowHeight)

    var heightChange = 0

    // lcc_nav.style.top = (originalWindowHeight - 88) + 'px'


    window.addEventListener("resize", function (e) {
        if((originalWindowHeight - window.innerHeight) < 0){

            heightChange = (originalWindowHeight - window.innerHeight) * -1.5

            //console.log('heightChange', heightChange)

            //if(heightChange > 0 && heightChange < 88){
                //lcc_nav.style.transform = "translateY(" + heightChange + "px)"
            //}
            
        }

    });


    $(window).scroll(function (event) {

        if(window.pageYOffset > 0){
            newScrollValue = window.pageYOffset;
            if (oldScrollValue < newScrollValue) {

                // Scrolling down

                if(direction == 'up'){
                    direction = 'down'
                }
                if(lcc_nav.classList.contains('lccNav_up')){

                    //we've just started to scroll down so unattach the nav and reset scroll distance
                    touchStart = window.pageYOffset
                    lcc_nav.classList.remove('lccNav_up')

                }else{
                    scrollDistance = window.pageYOffset - touchStart
                    if(scrollDistance > 0 && scrollDistance < 6){
                        //lcc_nav.style.bottom = (scrollDistance * -1) * 5 + 'px'

                        var translateYValue = (scrollDistance * -1) * 5 + 'px'
                        lcc_nav.style.transform = "translateY(" + translateYValue + ")";

                    }else if(scrollDistance > 5){
                        lcc_nav.style.transform = "translateY(88px)";
                        lcc_nav.classList.add('lccNav_down')
                    }

                    if(lccNavDrawer.classList.contains('lccNavDrawer_up')){
                        lccNavDrawer.classList.remove('lccNavDrawer_up');
                    }
                    
                    
                }
            } else if (oldScrollValue > newScrollValue) {

                // Scrolling down

                if(direction == 'down'){
                    direction = 'up'
                }
                if(lcc_nav.classList.contains('lccNav_down')){
                    //we've just started to scroll up so unattach the nav and reset scroll distance
                    touchStart = window.pageYOffset
                    lcc_nav.classList.remove('lccNav_down')
                }else{
                    scrollDistance = window.pageYOffset - touchStart
                    if(scrollDistance < 1 && scrollDistance > -6){
                        //lcc_nav.style.bottom = -100 - ((scrollDistance) * 5) + 'px'
                        var translateYValue = -88 - ((scrollDistance) * 5) + 'px'
                        lcc_nav.style.transform = "translateY(" + translateYValue + ")";
                    }else if(scrollDistance < -7){
                        //lcc_nav.style.bottom = null;
                        lcc_nav.style.transform = "translateY(0px)";
                        lcc_nav.classList.add('lccNav_up')
                    }
                }
            }
            oldScrollValue = newScrollValue;
        }


        console.log(window.scrollY)


    })

    document.getElementById('lccNavMore').addEventListener('click', function (e) {

        if (lccNavDrawer.classList.contains('lccNavDrawer_up')) {

            lccNavDrawer.classList.remove('lccNavDrawer_up');
            lccNavMoreImageInactive.style.display = "block"
            lccNavMoreImageActive.style.display = "none"
            
        } else {

            lccNavDrawer.classList.add('lccNavDrawer_up');
            lccNavMoreImageInactive.style.display = "none"
            lccNavMoreImageActive.style.display = "block"
        }

        e.preventDefault();
    });

    function handleTouchEnd() {

        console.log('touch end')

        setTimeout(function(){
            var bottom = parseInt(lcc_nav.style.bottom, 10) || 0
            if(bottom < -15){
                lcc_nav.style.bottom = null;
                lcc_nav.classList.add('lccNav_down')
                //touchStart = window.pageYOffset
            }else{
                lcc_nav.style.bottom = null;
                lcc_nav.classList.add('lccNav_up')
                //touchStart = window.pageYOffset
            }
        }, 50)

        
    }

    document.body.addEventListener("touchend", handleTouchEnd , false);

}

function mobile_nav() {

    if(!mobNavInitialised){
        mobNavInitialised = true;

        var nav_display = document.getElementById('lccNavDisplayBar');
        var lcc_nav = document.getElementById('lccNavMobile');

        // Hide Header on on scroll down
        var didScroll;
        var lastScrollTop = 0;
        var delta = 20;
        var navbarHeight = $('#header').outerHeight();

        var lccNavDrawer = document.getElementById('lccNavDrawer');
        var lccNavMoreImageInactive = document.getElementById('lccNavMoreImageInactive');
        var lccNavMoreImageActive = document.getElementById('lccNavMoreImageActive');

        var running = false;

        var touchStart = false;
        var scrollDistance = 0;

        var oldValue = 0
        var newValue = 0

        $(window).scroll(function (event) {

            newValue = window.pageYOffset;
              if (oldValue < newValue) {
                console.log("Up");
              } else if (oldValue > newValue) {
                console.log("Down");
              }
              oldValue = newValue;

            didScroll = true;
            if(!touchStart){
                touchStart = $(window).scrollTop()
            }

            //console.log($(window).scrollTop() - touchStart)
            scrollDistance = $(window).scrollTop() - touchStart

            if(lcc_nav.classList.contains('lccNav_up')){
                if(scrollDistance > 0 && scrollDistance < 21){
                    lcc_nav.style.bottom = (scrollDistance * -1) * 5 + 'px'
                }else if(scrollDistance > 20){
                    lcc_nav.classList.remove('lccNav_up')
                    lcc_nav.style.bottom = null;
                    touchStart = false
                }
                
            }
            else{
                if(scrollDistance < 0 && scrollDistance > -21){
                    lcc_nav.style.bottom = -100 - ((scrollDistance) * 5) + 'px'
                }else if(scrollDistance < -21){
                    lcc_nav.classList.add('lccNav_up')
                    lcc_nav.style.bottom = null;
                    touchStart = false
                }
            }
        });

        function touchBegin(e) {
            console.log('touch start')
            e.preventDefault();
        }

        function touchEnd() {
            console.log('touchEnd')
            // setTimeout(function(){
            //     touchStart = false
            // }, 800)
        }

        document.body.addEventListener("touchmove", touchBegin , false);
        document.body.addEventListener("touchend", touchEnd , false);


        document.addEventListener("touchmove", ScrollStart, false);
        document.addEventListener("scroll", Scroll, false);

        function ScrollStart() {
            //start of scroll event for iOS
            console.log('iOS touch start')
        }

        function Scroll() {
            //end of scroll event for iOS
            //and
            //start/end of scroll event for other browsers
            console.log('iOS scroll')
        }




        // setInterval(function () {
        //     if (didScroll) {
        //         hasScrolled();
        //         didScroll = false;
        //     }
        // }, 200);


        function hasScrolled() {
            
            var st = $(window).scrollTop();

            //Make sure they scroll more than delta
            if (Math.abs(lastScrollTop - st) <= delta)
                return;

            //console.log(lastScrollTop, delta)

            // If they scrolled down and are past the navbar, add class .nav-up.
            // This is necessary so you never see what is "behind" the navbar.
            if (st >= lastScrollTop) {
                lccNavDrawer.classList.remove('lccNavDrawer_up');
                lccNavMoreImageInactive.style.display = "block"
                lccNavMoreImageActive.style.display = "none"
                lcc_nav.classList.add('lccNavMobile--hide')

            }else if(st < lastScrollTop){
                lcc_nav.classList.remove('lccNavMobile--hide')
            }

            lastScrollTop = st;
        }

        
    }

    
}

function addClassNameListener(elemId, callback) {
    var elem = document.getElementById(elemId);
    var lastClassName = elem.className;
    window.setInterval(function () {
        var className = elem.className;
        if (className !== lastClassName) {
            callback();
            lastClassName = className;
        }
    }, 10);
}

function scrollEventThrottle(fn) {
    let last_known_scroll_position = 0;
    let ticking = false;
    window.addEventListener("touchend", function () {
        let previous_known_scroll_position = last_known_scroll_position;
        last_known_scroll_position = window.scrollY;
        if (!ticking) {
            window.requestAnimationFrame(function () {
                fn(last_known_scroll_position, previous_known_scroll_position);
                ticking = false;
            });
            ticking = true;
        }
    });
}


function debounce(func) {
    var timer;
    return function (event) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(func, 100, event);
    };
}

// Initialise sticky_nav
sticky_nav();